import React, { Component } from 'react';

import "./HeroUnit.css";

export default class HeroUnit extends Component {
    render() {
      return (
        <div className="jumbotron herounit">
            <div id="carouselExampleIndicators" className="carousel slide" data-ride="carousel">
  <ol className="carousel-indicators">
    <li data-target="#carouselExampleIndicators" data-slide-to="0" className="active"></li>
    <li data-target="#carouselExampleIndicators" data-slide-to="1"></li>
    <li data-target="#carouselExampleIndicators" data-slide-to="2"></li>
  </ol>
  <div className="carousel-inner">
    <div className="carousel-item active">
      <img className="d-block w-100" src="images/images/012.png" alt="Vielfältiges Angebot"/>
    </div>
    <div className="carousel-item">
      <img className="d-block w-100" src="images/images/020.png" alt="Auss  enbereich"/>
    </div>
    <div className="carousel-item">
      <img className="d-block w-100" src="images/images/006.png" alt="Herzlich Willkommen!"/>
    </div>
  </div>
  <a className="carousel-control-prev" href="#carouselExampleIndicators" role="button" data-slide="prev">
    <span className="carousel-control-prev-icon" aria-hidden="true"></span>
    <span className="sr-only">Previous</span>
  </a>
  <a className="carousel-control-next" href="#carouselExampleIndicators" role="button" data-slide="next">
    <span className="carousel-control-next-icon" aria-hidden="true"></span>
    <span className="sr-only">Next</span>
  </a>
</div>

        </div>      
      );  
    }
  }